export const SIDEBAR_CONTAINER_ID = 'sidebar-container'

export const WORK_AREA_ID = 'work-area'

export const POPUP_CONTENT_ID = 'popup-scroll-content-ui'

